import { WINDOW_WIDTH } from "../interfaces/layouts";

export const getInnerHeight = ( elm: HTMLElement ) : number => {
    var computed = getComputedStyle(elm),
        padding = parseInt(computed.paddingTop) + parseInt(computed.paddingBottom);
    
    return elm.offsetHeight 
}

export const getWindowWidthFromElementWidth = (elementWidth: number): keyof typeof WINDOW_WIDTH => {
    const dimensions: string[] = Object.keys( WINDOW_WIDTH ).filter((v) => isNaN(Number(v)))
      
    const dimension = dimensions.filter( (key: string, i: number) => {
        const max = WINDOW_WIDTH[ dimensions[ i ] as keyof typeof WINDOW_WIDTH ]
        const min = WINDOW_WIDTH[ (dimensions[ i + 1 ]) as keyof typeof WINDOW_WIDTH ]
        const bool: boolean =  elementWidth > min 
            && ( i < dimensions.length - 1
                ?
                elementWidth < max
                :
                true )
        return bool
    })
    return ( dimension[0] || "PANEL" ) as keyof typeof WINDOW_WIDTH
}